import { Component, Input, OnInit } from '@angular/core';
import { ArbeitsbereichService } from 'src/app/shared/service/arbeitsbereich.service';
import { CsvExportService } from './service/csv-export.service';
import { AgGridAngular } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';
import { AgGridListViewService } from '../../services/ag-grid-list-view.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ListViewColumn } from '../../../config/model/listview-config.model';

@Component({
    selector: 'ag-grid-csv-export-button',
    templateUrl: './csv-export-button.component.html',
    styleUrls: ['./csv-export-button.component.scss'],
    standalone: false
})
export class AgGridCsvExportButtonComponent implements OnInit {
  @Input() private tabLayer: any;
  @Input() agGrid: AgGridAngular;

  private tabLayerName: string;

  generatingCsv = false; // this property is used to update the dom when e csv is generated

  constructor(
    private csvExportService: CsvExportService,
    private agGridlistViewService: AgGridListViewService,
    private arbeitsBereichService: ArbeitsbereichService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit() {}

  /**
   * gets called on buttonclick &
   * creates a csv with the data from the active tab & downloads it
   */
  exportAgGridToCSV() {
    this.generatingCsv = true;
    const outFields = [];
    const titles = [];

    this.getlistViewColumnsFromConfig().subscribe(lvColumns => {
      this.agGridlistViewService.totalTableRecords = this.agGrid.api.getDisplayedRowCount();
      lvColumns.forEach(column => {
        outFields.push(column.prop.replace('attributes.', ''));
        titles.push(this.translate.instant(column.name));
      });

      const whereClauses = this.agGridlistViewService.buildAgGridFilterModelWhere(this.agGrid.api.getFilterModel());
      const orderByFields = this.agGridlistViewService.createOrderByFields(this.agGrid.api.getColumnState().filter(x => x.sort));

      this.csvExportService
        .getDataForCSV(this.tabLayer, whereClauses, orderByFields, outFields)
        .subscribe((features: string[][]) => {
          features.forEach((feature: string[], index) => {
            const newFeature = feature.map(attribute => {
              if (attribute) {
                attribute = attribute.toString().replace(/\n/g, ' ').replace(/\r/g, '').replace(/"/g, '""');
              }
              return attribute;
            });
            features[index] = newFeature;
          });
          features.unshift(titles);
          this.generateCSVAndLink(features);
          this.generatingCsv = false;
        });
    });
  }

  /**
   * gets the data for the csv & creates a download link
   */
  public generateCSVAndLink(features: string[][]) {
    const csvContent = this.csvExportService.generateCSVContent(features);
    this.createBlobForDownload(csvContent);
  }

  /**
   * creates a blob from csvstring & downloads it
   * @csvContent the csvstring
   */
  private createBlobForDownload(csvContent: string) {
    const blob = new Blob(['\uFEFF', csvContent], { type: 'text/csv;charset=utf-8,\uFEFF;' });
    this.downloadLink(blob);
  }

  /**
   * gets all the defined columns in the config, to create the csv export
   */
  private getlistViewColumnsFromConfig(): Observable<ListViewColumn[]> {
    return this.agGridlistViewService.getListViewTabConfig().pipe(
      map(tabs => {
        const activeTab = tabs.find(tab => tab.tabLayer['url'] === this.tabLayer);
        this.tabLayerName = activeTab.tabLayer.title;
        return activeTab.columns;
      })
    );
  }

  /**
   * creates a dom element via we can download the generated csv
   */
  private downloadLink(blob: Blob) {
    const a = document.createElement('a');
    if (a) {
      // feature detection
      // Browsers that support HTML5 download attribute
      console.log(a);
      const url = URL.createObjectURL(blob);
      a.setAttribute('href', url);
      a.setAttribute('download', this.csvExportFileName());
      a.style.visibility = 'hidden';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }

  /**
   * generates a nme for csv (data-ab-layer.csv)
   */
  private csvExportFileName(): string {
    const abName = this.translate.instant(this.arbeitsBereichService.selectedArbeitsbereich.name);
    return `${this.dateToday()}-${abName}-${this.tabLayerName}.csv`.replace(' ', '_');
  }

  /**
   * returns todas date (yyyymmdd)
   */
  private dateToday(): string {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();

    return `${yyyy}${mm}${dd}`;
  }
}
